(function () {
  "use strict";

  EditGroupNameSidebarCtrl.$inject = ['$scope', 'modalHelper', 'groupsResource', 'untitledFieldService'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditGroupNameSidebarCtrl', EditGroupNameSidebarCtrl);

  function EditGroupNameSidebarCtrl($scope, modalHelper, groupsResource, untitledFieldService) {
    var storedGroupName = $scope.selectedGroup.name;

    $scope.serverCallInProgress = false;

    $scope.viewModel = {
      group: $scope.selectedGroup
    };

    var setUntitledFields = this.setUntitledFields = function () {
      untitledFieldService.nameEmptyFields({collection: $scope.groups, nameProp: 'name'});
    };

    $scope.cancelChanges = function () {
      clean();
      $scope.changeSidebar('pages/group/groupDetailSidebar.html');
    };

    $scope.applyChanges = function () {
      setUntitledFields();
      $scope.viewModel.group.addNumberSuffix = true;

      $scope.serverCallInProgress = true;
      groupsResource.updateGroup($scope.viewModel.group, function () {
        $scope.refreshData();
        $scope.serverCallInProgress = false;
        $scope.manageGroupsEditors.editGroupNameSidebarDirty = false;
        $scope.changeSidebar('pages/group/groupDetailSidebar.html');
      });

      $scope.serverCallInProgress = false;
    };

    function clean() {
      $scope.manageGroupsEditors.editGroupNameSidebarDirty = false;
      $scope.serverCallInProgress = false;
    }

    function markDirty() {
      $scope.manageGroupsEditors.editGroupNameSidebarDirty = true;
    }

    $scope.canApplyChanges = function () {
      return $scope.manageGroupsEditors.editGroupNameSidebarDirty && !$scope.serverCallInProgress;
    };

    $scope.groupNameEdited = function () {
      if ($scope.viewModel.group.name != storedGroupName)
        markDirty();
      else
        clean();
    }
  }

})();
